// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DemoSystemV3_wrapper__3SU1L","inner_content":"DemoSystemV3_inner_content__r5MzI"};